import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import Logo from "../common/Logo";
import LeanGainsLogo from '../../assets/LeanGainsLogo.png';
const LEANGAINS_URL = 'https://www.leangains.ai/';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const openCookieSettings = (e) => {
    e.preventDefault();
    if (typeof window.openCookieSettings === 'function') {
      window.openCookieSettings();
    }
  };

    return (
        <footer className="global-footer">
            <div className="footer-main">
                <div className="footer-container">
                    {/* Row 1 - Logo + Nav Links */}
                    <div className="footer-top-section">
                        <div className="footer-logo">
                            <Logo linkTo="/" />
                        </div>
                        <div className="footer-nav-container">
                            <div className="footer-nav">
                                <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
                                <Link to="/terms-and-conditions" className="footer-link">Terms and Conditions</Link>
                                <a href="#cookie-settings" onClick={openCookieSettings} className="footer-link">Cookie Settings</a>
                                <Link to="/freedom-of-speech-policy" className="footer-link">Freedom Of Speech Policy</Link>
                                <a href="mailto:info@yourplat4orm.com" className="footer-link">Contact Us</a>
                            </div>
                        </div>
                    </div>

                    {/* Row 2 - Divider */}
                    <div className="footer-divider"></div>

                    {/* Row 3 - Legal + LeanGains */}
                    <div className="footer-bottom">
                        <div className="copyright">
                            YourPlat4orm Limited is a company registered in England and Wales
                            <span className="separator"> | </span>
                            Company no: 15955054
                            <span className="separator"> | </span>
                            Copyright 2024 - {currentYear}
                        </div>
                        <div className="powered-by">
                            <span>Powered by </span>
                            <a href={LEANGAINS_URL} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={LeanGainsLogo}
                                    alt="LeanGains Logo"
                                    className="leangains-logo"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;